define('type/stream/Serum.RealtimeStream',[
  'common/js/lib/Serum.Time',
  'common/module/realtime/Serum.RelationalRealtimeWidget',
  'common/js/lib/Serum.ScrollTrigger',
  'common/js/lib/Serum.Pubsub',
  'common/js/lib/Serum.Moment',
  'jquery'
], function(Time, RelationalRealtimeWidget, ScrollTrigger, Pubsub, moment, $) {
  'use strict';

  /* convenience function for detecting scrolling past an element */
  function Waypoint($element, options) {
    // PUB-12817 - reduce ridiculous amounts of errors because of no null checking
    if (!$element.length) {
      return;
    }

    var reached = false;

    function onScroll(position) {
      var topOffset = $element.offset().top;    //Must happen onScroll in case content above has changed height

      if (!reached && position.top > topOffset) {
        options.enter();
        reached = true;
      }

      if (reached && position.top < topOffset) {
        options.exit();
        reached = false;
      }
    }

    Pubsub.subscribe(Pubsub.topics.DID_SCROLL, onScroll);
  }


  /* stream decorator */
  function RealtimeStream($stream) {

    var unrenderedInsertions = 0;
    var highestUnrederedInsertionIndex = -1;
    var streamHeaderIsVisible = true;
    var relationPerspective = $stream.data('relationPerspective');

    var stream = new RelationalRealtimeWidget($stream, {
      onBeforeInsert : function($content) {
        $content.addClass('new');
      },

      onAfterInsert : function($content) {
        var $animated;

        if (relationPerspective === 'REFERENCE') {
          $animated = $content.find('> span');
          $animated.animate({ maxHeight : 40 }, function() {
            $animated.animate({ opacity : 0 }, function() {
              $animated.animate({ opacity : 1 });
            });
          });
          return;
        }

        $animated = $content.find('.bulletin > div');
        $animated.animate({ maxHeight: 700 }, 1000, function() {
          $animated.animate({ opacity: 1 }, 400, function() {
            $content.removeClass('new');
            $animated.attr('style', '');
            formatDateStrings($content.find('.bulletin-text time[datetime]'));
          });
        });
      },

      relationElements : function() {
        return $stream.find('.stream-item');
      },

      relationContainer : function() {
        return $stream.find($stream.hasClass('lean') ? '.stream-lean-content' : '.stream-content');
      },
      relationTemplate : function(relation) { // eslint-disable-line no-unused-vars
        return '<li class="stream-item relation"></li>';
      }
    });

    stream.setDefaultPerspective(relationPerspective);

    function onRealtimeInsertion(event, data) {
      var index = data.index;
      if (data.context !== 'items') {
        return;
      }

      if (index > highestUnrederedInsertionIndex && index < stream.getRelationCount()) {
        unrenderedInsertions++;
        Pubsub.publish('/stream/underedInsertionCountChange', {
          stream : $stream,
          unrenderedInsertionCount : unrenderedInsertions
        });
        highestUnrederedInsertionIndex = data.index;
      }
    }

    function setupShortcutButton() {
      $stream.on('click', '.stream-top-shortcut', function() {
        $('body, html').animate({ scrollTop: $stream.offset().top - 15 }, 800);
      });
    }

    function setupExpandableImages() {
      $(document).on('click', '.bulletin-attachment.image', function() {
        $(this).toggleClass('bulletin-attachment-expanded');
        setTimeout(function() {
          Pubsub.publish(Pubsub.topics.CHANGE_IMAGES, { imgEls : $(this) });
        }, 700);
      });
    }

    function setupPagination() {
      var $button = $stream.find('.stream-pagination-button');

      $stream.on('click', '.stream-pagination-button', function() {
        Pubsub.publish(Pubsub.topics.TRACK_EVENT, {
          category : 'Stream',
          action : 'Pagination click'
        });

        $button.addClass('is-busy');

        stream.setRelationLimit(stream.getRelationLimit() + 5);

        if (stream.isPaused()) {
          stream.unpause();
          $button.removeClass('is-busy');
        } else {
          stream.synchronize().done(function() {
            $button.removeClass('is-busy');
          });
        }
      });

      $stream.on('realtimerepaint', function(event, data) {
        //TODO: need some more data from backend here?
        //console.log(data.master.length, stream.getRelationLimit());
        if (data.master.length < stream.getRelationLimit()) {
          $stream.find('.stream-pagination-button').parent().hide();
        }else{
          $stream.find('.stream-pagination-button').parent().show();
        }
      });
    }

    function onBeforeRealtimeDeletion(e, data) { // eslint-disable-line no-unused-vars
      //TODO: remove this?
    }

    function formatDate(today, time) {
      var daysBetween = today.diff(time, 'days'),
        yesterday = today.clone().startOf('day').subtract(1, 'days');

      if(yesterday.isSame(time, 'day')) {
        return 'I går';
      }
      if(daysBetween < 5) {
        var day = time.format('dddd');
        return day.charAt(0).toUpperCase() + day.substring(1);
      }
      return undefined;
    }

    function formatDateStrings($items) {
      var today = moment(Time.now());
      $items.each(function() {
        var $item = $(this),
          time = moment($item.data('timestamp'));

        if(!today.isSame(time, 'day')) {
          $item.find('.bulletin-publish-clock').show();
          $item.find('.bulletin-publish-date').html(formatDate(today, time)).show();
          if(!today.isSame(time, 'year')) {
            $item.find('.bulletin-publish-year').show();
          }
        }
      });
    }

    function onVisibilityStateChange(data) {

      if (data.visible && stream.isPaused() && streamHeaderIsVisible) {
        stream.unpause();

        $stream.off('realtimeinsertion', onRealtimeInsertion);
        highestUnrederedInsertionIndex = -1;
        unrenderedInsertions = 0;

        Pubsub.publish('/stream/underedInsertionCountChange', {
          stream : $stream,
          unrenderedInsertionCount : unrenderedInsertions
        });
      } else if (!data.visible) {
        stream.pause();
        $stream.on('realtimeinsertion', onRealtimeInsertion);
      }
    }

    function setupVisibilityStateChange() {
      Pubsub.subscribe('VISIBILITY_DID_CHANGE_STATE', onVisibilityStateChange);
    }

    function setupEvents() {
      new Waypoint($stream.find('.stream-content'), { // eslint-disable-line no-new
        enter : function() {
          stream.pause();
          $stream.on('realtimeinsertion', onRealtimeInsertion);
          streamHeaderIsVisible = false;
        },
        exit : function() {
          streamHeaderIsVisible = true;
          stream.unpause();
          $stream.off('realtimeinsertion', onRealtimeInsertion);
          highestUnrederedInsertionIndex = -1;
          unrenderedInsertions = 0;

          Pubsub.publish('/stream/underedInsertionCountChange', {
            stream : $stream,
            unrenderedInsertionCount : unrenderedInsertions
          });
        }
      });

      setupShortcutButton();
      setupPagination();
      setupExpandableImages();
      formatDateStrings($stream.find('.stream-item .bulletin-text time[datetime]'));
      setupVisibilityStateChange();

      $stream.on('beforerealtimedeletion', onBeforeRealtimeDeletion);
    }

    (function initialize() {
      setupEvents();
      $stream.data('realtime-stream', stream);
      $stream.trigger('widget.initialized');
    })();

    return stream;
  }

  return RealtimeStream;

});

